export class CalculatorEnhancedModel {
  weight: number;
  specie: number;
  gender: number;
  raceId: number;
  sizeId: number;
  birthDate: Date;
  ageGroupId: number;
  physicalActivity: number;
  clinicalCharacteristics: number[];
  productId?: number;
  device: number;
  source: number;
  calculatorType: number;
  orientationPurposeId?: number;
  stageDisease?: number;
  score?: number;
  petId?: number;
  isOrientation?: boolean;
  useCombinedCompleteProducts?: boolean;
  secondaryProductId?: number; //wetFood
  primaryProductPercentage?: number;
  secondaryProductPercentage?: number;
}
